/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { detDependencies } from './dependenciesDet.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { identityDependencies } from './dependenciesIdentity.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated.js';
import { createInv } from '../../factoriesAny.js';
export var invDependencies = {
  absDependencies,
  addScalarDependencies,
  detDependencies,
  divideScalarDependencies,
  identityDependencies,
  matrixDependencies,
  multiplyDependencies,
  typedDependencies,
  unaryMinusDependencies,
  createInv
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesInv.generated.js
// module id = fMSi
// module chunks = 3